import { render } from "./mvt-searchfilter.vue?vue&type=template&id=56043fac"
import script from "./mvt-searchfilter.js?vue&type=script&lang=js"
export * from "./mvt-searchfilter.js?vue&type=script&lang=js"

import "./mvt-searchfilter.vue?vue&type=style&index=0&id=56043fac&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__